import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.CreatePage,
  title: 'Create Page',
  category: ComponentCategory.Layout,
  showInLibrary: false,
};
